import React from 'react'
import {ReactComponent as Tractor} from 'style/asset/tractor.svg'
import PropTypes from 'prop-types'

const MachineIcon = (props) => {
  const {className, ...rest} = props

  return <Tractor {...rest} className={className} />
}

MachineIcon.propTypes = {
  className: PropTypes.string,
  rest: PropTypes.object,
}

export default MachineIcon
